import React, { useEffect, useState } from "react";
import { Form, Input, InputNumber, Button } from "antd";
import { componentType } from "../../constants/index";
import { nullSafe, canCorrectField, tableInputWidth } from "../../utils/fields";
import { isEmpty } from "../../../../business/utils";
import { FormUtilitaries, Utilitaries } from "../../../../business";
import ReactQuill from "react-quill";

const { TextArea } = Input;

const QaInput = ({
    type,
    itemData,
    onChange,
    currentTaskStatus,
    label,
    textLabel,
    readonly,
    renderContext,
    error,
    openEditorFieldModal,
    formItemStyle,
    correctForm,
    fixedSize,
    showFieldEditorModal,
}) => {
    const [currentValue, setCurrentValue] = useState();

    useEffect(() => {
        if ((isEmpty(currentValue) && !isEmpty(itemData.value)) || currentValue !== nullSafe(itemData.value)) {
            setCurrentValue(nullSafe(itemData.value));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemData.value]);

    const handleChange = (event) => {
        const { value } = event.target;
        setCurrentValue(value);
    };

    const showLabel =
        itemData?.["@etiqueta"] !== undefined &&
        !itemData?.["@etiqueta"]?.trim() &&
        itemData?.["@grupo"] &&
        !itemData?.["@ajuda"]
            ? {}
            : { label };

    const autosize =
        renderContext === "column" && showFieldEditorModal
            ? { minRows: 1, maxRows: 2 }
            : { minRows: renderContext === "column" ? 1 : 2, maxRows: 50 };
    const textAreaStyle = renderContext === "column" && showFieldEditorModal && fixedSize ? { width: "150px" } : {};

    const textAreaProps = {
        autoSize: autosize,
        style: textAreaStyle,
        allowClear: renderContext === "column" && showFieldEditorModal ? false : true,
    };

    const canEdit = canCorrectField(itemData) && correctForm;

    const disabled = canEdit ? false : currentTaskStatus || readonly;

    const inputWidth = tableInputWidth(itemData, fixedSize);

    const stylesInput =
        renderContext === "column" && showFieldEditorModal && type !== componentType._inputNumber
            ? {
                  display: "flex",
                  ...inputWidth,
              }
            : inputWidth;

    let stylesInputNumber = { width: "100%" };
    if (renderContext === "column" && type === componentType._inputNumber && itemData?.["dataIndex"] === "meta") {
        stylesInputNumber = { width: 100 };
    }

    const getInputLength = () => {
        let size = 0;
        const style = itemData["@estilo"];
        if (style) {
            if (style.includes("maxLength")) {
                size = style.match(/(?<=(maxLength))[0-9]+/);

                try {
                    size = parseInt(size[0]);
                } catch (err) {}
            }
        }
        if (!size || !style) {
            return {};
        }

        return { maxLength: size };
    };

    const maxSize = getInputLength();

    const getLink = () => {
        const protocol = window.location.protocol;
        const host = window.location.host;
        const link = `${protocol}//${host}`;
        setCurrentValue(link);
        onChange(link);
    };

    return (
        <>
            <Form.Item {...showLabel} style={formItemStyle} colon={itemData["@etiqueta"] !== ""}>
                <div style={stylesInput}>
                    {type === componentType._input && (
                        <Input
                            {...maxSize}
                            disabled={disabled}
                            placeholder={itemData["@placeholder"]}
                            value={currentValue}
                            allowClear
                            onChange={handleChange}
                            onBlur={() => onChange(currentValue)}
                            style={FormUtilitaries.highlightsErrors(currentValue, itemData.required)}
                        />
                    )}

                    {/* SE NÂO FOR DRAFT JS */}
                    {(type === componentType.shortText ||
                        type === componentType.areaTexto ||
                        type === componentType.text) &&
                        Utilitaries.toString(itemData?.["@estilo"])?.includes("draft-js") === false && (
                            <TextArea
                                onChange={handleChange}
                                onBlur={() => onChange(currentValue)}
                                {...textAreaProps}
                                disabled={disabled}
                                value={currentValue}
                                compact
                                style={FormUtilitaries.highlightsErrors(currentValue, itemData.required)}
                                // allowClear
                                placeholder={
                                    itemData["@placeholder"] || "Introduza " + itemData["@etiqueta"]?.toLowerCase()
                                }
                            />
                        )}
                    {/* SE FOR DRAFT JS */}
                    {(type === componentType.shortText ||
                        type === componentType.areaTexto ||
                        type === componentType.text) &&
                        Utilitaries.toString(itemData?.["@estilo"])?.includes("draft-js") && (
                            <ReactQuill
                                theme="snow"
                                readOnly={disabled}
                                modules={{
                                    toolbar: [
                                        [{ header: [1, 2, 3, false] }],
                                        ["bold", "italic", "underline", "strike", "blockquote", "link"],
                                        [{ list: "ordered" }, { list: "bullet" }],
                                        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                                        // [{ font: [] }],
                                        // [{ align: [] }],
                                        ["clean"],
                                    ],
                                }}
                                value={currentValue}
                                onChange={(value) => {
                                    setCurrentValue(value);
                                }}
                                onBlur={(pre, sour, edit) => {
                                    onChange(edit.getHTML());
                                }}
                                style={{ minHeight: "500px" }}
                                {...textAreaProps}
                            />
                        )}

                    {type === componentType._inputNumber && (
                        <InputNumber
                            style={{
                                ...FormUtilitaries.highlightsErrors(nullSafe(itemData.value), itemData.required),
                                ...stylesInputNumber,
                            }}
                            allowClear
                            value={nullSafe(itemData.value)}
                            disabled={disabled}
                            onBlur={onChange}
                            placeholder={itemData.placeholder}
                        />
                    )}
                    {renderContext === "column" && showFieldEditorModal && type !== componentType._inputNumber && (
                        <Button
                            style={{ marginLeft: 5 }}
                            icon="edit"
                            onClick={() =>
                                openEditorFieldModal({
                                    name: textLabel,
                                    onChange,
                                    disabled, //: currentTaskStatus || readonly || canCorrectField(itemData),
                                    value: nullSafe(itemData.value),
                                })
                            }
                        />
                    )}
                </div>
                {error && <span style={{ color: "red" }}>{error}</span>}
                {Utilitaries.toString(itemData?.["@estilo"]).includes("link_app") && (
                    <div style={{ marginTop: 0 }}>
                        <Button type="link" size="small" onClick={getLink}>
                            Carregar link da aplicação
                        </Button>
                    </div>
                )}
            </Form.Item>
        </>
    );
};
export default QaInput;
